import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { NgToastService } from 'ng-angular-popup';
import { DomSanitizer } from '@angular/platform-browser';
import { SidebarService } from '@/app/services/shared/sidebar.service';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { MapDialogComponent } from '../global/dialog-boxes/map-dialog/map-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ProjectWrapperComponent } from './project-stages/project-wrapper/project-wrapper.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { FilterToolComponent } from '../global/filter-tool/filter-tool.component';
import { ProgressService } from '@/app/services/shared/progress.service';
import { DialogUtilityService } from '@/app/services/utility/dialog-utility.service';
interface Person {
  Project_ID: string;
  Name: string;
  Description: string;
  StartDate: string;
  EndDate: number;
  ProposedStartDate: string;
  ExpectedEndDate: number;
  Action: string;
}

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    // WrapperComponent,
    FilterToolComponent,
    ProjectWrapperComponent,
  ],
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.css'],
})
export class ProjectsComponent implements OnInit {
  filteredProjects: any;
  projects: any;
  entriesPerPage = 5;
  searchQuery = '';
  currentPage = 1;
  totalItems = 0;
  dropdownOpen = false;
  openDropdownIndex: number | null = null;
  sortColumn: keyof Person = 'Name'; // Default sorting column
  sortDirection: 'asc' | 'desc' = 'asc';
  requestedprojects: any;
  requestedPqqProjects: any;
  fetchedProjects: any;
  isProjectEdit = false;
  isProjectOpen = false;
  viewMode: 'list' | 'grid' = 'list';
  selectedItem = ''; // Tracks the currently selected button
  constructor(
    private router: Router,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private sanitizer: DomSanitizer,
    private SidebarService: SidebarService,
    private getProjectIdService: GetProjectIdService,
    private dialog: MatDialog,
    private tenderingService: TenderingService,
    private ActivatedRoute: ActivatedRoute,
    private progressService: ProgressService,
    private dialogService: DialogUtilityService
  ) {}

  selectItem(item: string): void {
    this.selectedItem = item; // Update the selected button
  }

  ngOnInit(): void {
    this.getAllProjects();
    this.getRequestedProjects();

    this.ActivatedRoute.queryParams.subscribe((params) => {
      const mode = params['viewMode'];
      if (mode === 'list' || mode === 'grid') {
        this.viewMode = mode;
      }
    });
    this.dialogService.closeProjectBriefDialog$.subscribe(() => {
      this.handleDialog();
    });
  }

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  handleDialog() {
    this.isProjectEdit = false;
    this.isProjectOpen = false;
    this.getAllProjects();
    this.dialog.closeAll();
  }
  openMapDialog(longitude: number, latitude: number): void {
    if (longitude && latitude) {
      this.dialog.open(MapDialogComponent, {
        width: '80vw',
        height: '70vh',
        panelClass: 'custom-dialog-container',
        maxWidth: '100vw',
        maxHeight: '100vh',
        autoFocus: false,
        data: { longitude, latitude },
      });
    } else {
      console.error('Longitude and latitude are required to display the map');
    }
  }

  getAllProjects(): void {
    this.projectsService.getAllProjects().subscribe({
      next: (data) => {
        this.projects = data.data;
        this.fetchedProjects = data.data;
        this.filteredProjects = data.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  // Reuested Projects
  getRequestedProjects(): void {
    this.tenderingService.getProjectsRequested().subscribe({
      next: (data) => {
        this.requestedprojects = data?.data;
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  deleteProject(project: any) {
    this.projectsService.deleteProject(project.id).subscribe({
      next: () => {
        this.toast.success('Project deleted successfully', 'SUCCESS', 4000);
        localStorage.removeItem('project-name');
        this.getAllProjects();
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
        this.toast.danger('Error while deleting project', 'DANGER', 4000);
      },
    });
  }

  // Pagination control methods
  goToPage(page: number): void {
    this.currentPage = page;
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.entriesPerPage);
  }
  navigateToProjectDetail() {
    this.SidebarService.toggleSidebar(true);
    this.router.navigate(['/project-detail']);
  }
  openProject(project: any) {
    localStorage.setItem('isEdit', String(true));
    localStorage.setItem('projectId', project.id);
    localStorage.setItem('project-name', project.name);
    this.getProjectIdService.setProjectId(project.id);

    //navigate to folder project development
    // this.router.navigate(['/project-development', project.id], {
    //   queryParams: {
    //     name: project.name,
    //     projectIdentifier: project.project_name_id,
    //   },
    // });
    this.router.navigate(['/brief-plan-view']);

    localStorage.setItem('isApproved', String(true));
    const stages = {
      stage1: true,
      stage2: false,
      stage3: false,
    };
    localStorage.setItem('stages', JSON.stringify(stages));
  }
  openHistory(project: any) {
    localStorage.setItem('isEdit', String(true));
    localStorage.setItem('projectId', project.id);
    localStorage.setItem('project-name', project.name);
    this.getProjectIdService.setProjectId(project.id);

    //navigate to folder project development
    // this.router.navigate(['/project-development', project.id], {
    //   queryParams: {
    //     name: project.name,
    //     projectIdentifier: project.project_name_id,
    //   },
    // });
    this.router.navigate(['/project-revision']);

    localStorage.setItem('isApproved', String(true));
    const stages = {
      stage1: true,
      stage2: false,
      stage3: false,
    };
    localStorage.setItem('stages', JSON.stringify(stages));
  }

  navigateToRequestedProject(project: any) {
    const projectId = project.project_id || project.id;

    this.getProjectIdService.setProjectId(projectId);
    localStorage.setItem('projectId', projectId);
    localStorage.setItem('eoi_id', project.eoi_id);
    localStorage.setItem('project-name', project.name);
    // navigate to folder project requests
    // this.router.navigate(['/project-requests', projectId], {
    //   queryParams: {
    //     projectName: project.name,
    //     projectIdentifier: project.project_name_id,
    //   },
    // });
    // this.router.navigate(['/project-revision']);
  }

  createNewProject() {
    localStorage.removeItem('isEdit');
    localStorage.removeItem('projectId');
    localStorage.setItem('isApproved', String(false));
    this.getProjectIdService.setProjectId('');
    const stages = {
      stage1: false,
      stage2: false,
      stage3: false,
    };
    localStorage.setItem('stages', JSON.stringify(stages));
    this.isProjectOpen = true;
    this.progressService.clearForms();
  }

  handleEdit(projectId: string) {
    this.getProjectIdService.setProjectId(projectId);
    this.isProjectOpen = true;
  }

  truncateDescription(description: string): string {
    const maxLength = 30; // Set the max length to 30 characters

    if (description?.length > maxLength) {
      return description?.slice(0, maxLength) + ''; // Truncate and append ellipses
    }
    return description; // Return the original description if it's shorter than the limit
  }
  onSearch(query: string) {
    if (query.trim() === '') {
      this.filteredProjects = this.projects; // Show all projects if search query is empty
    } else {
      this.filteredProjects = this.projects.filter((project: any) => {
        const lowerCaseQuery = query.toLowerCase();
        return (
          (project.project_name_id &&
            project.project_name_id.toLowerCase().includes(lowerCaseQuery)) ||
          (project.name &&
            project.name.toLowerCase().includes(lowerCaseQuery)) ||
          (project.description &&
            project.description.toLowerCase().includes(lowerCaseQuery)) ||
          (project.start_date &&
            project.start_date.toLowerCase().includes(lowerCaseQuery))
        );
      });
    }
  }

  handleSearch(query: string) {
    console.log('Search Query:', query);
    this.onSearch(query);
  }

  handleClearAll() {
    console.log('Clear All clicked');
  }

  viewType(mode: 'list' | 'grid'): void {
    this.viewMode = mode;
    // Update the query parameter for viewMode
    this.router.navigate([], {
      relativeTo: this.ActivatedRoute,
      queryParams: { viewMode: mode },
      queryParamsHandling: 'merge', // Merge with other query parameters
    });
  }
  // Show the location of the project in detail
  getLocation(project: any): string {
    if (!project) return '';
    // Collect only non-null and non-undefined values
    const locationParts = [
      project?.country?.name,
      project?.city,
      project?.zip,
    ].filter((value) => value); // Removes null, undefined, and empty strings

    return locationParts.join(', '); // Join with commas
  }
}
